import { Route, Routes } from 'react-router-dom';
import { NotFound, IncidentType } from '@pages';
import { Protected } from '@components';

function RoutesIncidentType() {
  return (
    <Protected>
      <Routes>
        <Route index element={<IncidentType />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}

export default RoutesIncidentType;
